import { useEffect, useState } from 'react';

interface Props {
  onSetHighlightedId: (id: string) => void;
  onSetHighlightedIds?: (ids: string[]) => void;
  reset: () => void;
  delay?: number
}

const useHighlightById = ({
  onSetHighlightedId,
  onSetHighlightedIds,
  reset,
  delay = 2000,
}: Props) => {
  const [highlightedById, setHighlightedById] = useState<string>();
  const [highlightedByIds, setHighlightedByIds] = useState<string[]>();

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    return () => {
      if (highlightedById) {
        onSetHighlightedId(highlightedById);

        timer = setTimeout(() => {
          reset();
          clearTimeout(timer);
        }, delay);
      }
    };
  }, [onSetHighlightedId, reset, highlightedById, delay]);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    return () => {
      if (highlightedByIds && onSetHighlightedIds) {
        onSetHighlightedIds(highlightedByIds);

        timer = setTimeout(() => {
          reset();
          clearTimeout(timer);
        }, delay);
      }
    };
  }, [onSetHighlightedIds, reset, highlightedByIds, delay]);

  return {
    setHighlightedById,
    setHighlightedByIds,
  };
};

export default useHighlightById;
